/**
 * Variable-Length Quantity — кодирование целых чисел в SMF (Variable-
 * Length Quantity). 7 бит данных на байт + старший бит как «продолжение».
 * Стандарт ограничивает длину 4 байтами; парсер бросает `null` при
 * превышении (что исходный код трактовал как «конец потока»).
 */
export const readVLQ = (
  input: Uint8Array,
  pos: number,
  end: number
): { value: number; next: number } | null => {
  let value = 0;
  let p = pos;
  let read = 0;
  while (p < end) {
    const b = input[p]!;
    p += 1;
    read += 1;
    value = (value << 7) | (b & 0x7f);
    if ((b & 0x80) === 0) break;
    if (read > 4) return null;
  }
  if (read === 0) return null;
  return { value, next: p };
};

export const writeVLQ = (out: number[], value: number): void => {
  let v = Math.max(0, Math.floor(value));
  if (v === 0) {
    out.push(0);
    return;
  }
  const stack: number[] = [];
  stack.push(v & 0x7f);
  v >>= 7;
  while (v > 0) {
    stack.push((v & 0x7f) | 0x80);
    v >>= 7;
  }
  for (let i = stack.length - 1; i >= 0; i -= 1) {
    out.push(stack[i]!);
  }
};